// extracted by css-extract-rspack-plugin
export default {"mutedLabel":"mutedLabel-D4crTP"};